import {RootState} from '../..';

export const getActiveVariant = (state: RootState) => state.ui.usability.activeVariant;
